import type { InputWithLabelElement } from './types'

import { Body, Div, Img, Span, TextArea } from 'components/common/atoms'
import { COLOR } from 'styles/constants'

interface TextAreaWithLabelProps extends InputWithLabelElement<HTMLTextAreaElement> {
  textAreaHeight?: string
  noResize?: boolean
  $borderRadius?: string
}

export const TextAreaWithLabel: React.FC<TextAreaWithLabelProps> = ({
  id,
  label,
  name,
  value,
  error,
  disabled,
  isRequired,
  showErrorIcon,
  onChange,
  onBlur,
  onFocus,
  placeholder,
  textAreaHeight = '160px',
  noResize = true,
  $borderRadius,
  ...props
}) => (
  <Div {...props}>
    <Span as="label" id={`${id}Label`} htmlFor={id} $textStyle="body" $block>
      {label}
      {isRequired && <Body $color={COLOR.RED_LV2}> *</Body>}
    </Span>
    <TextArea
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      placeholder={placeholder}
      disabled={disabled}
      $error={!!error}
      $width="100%"
      $height={textAreaHeight}
      $margin="8px 0 0"
      $display="block"
      $noResize={noResize}
      $borderRadius={$borderRadius}
    />
    {error && typeof error === 'string' && (
      <Div className="d-flex align-items-center" $mt="8">
        {showErrorIcon && (
          <Img
            src="../profile/icon/circle-exclaimation-outline.svg"
            alt="text-area-error-icon"
            $width="16px"
            $height="16px"
            $mr="8"
          />
        )}
        <Body $textStyle="caption" $color={COLOR.RED_LV2}>
          {error}
        </Body>
      </Div>
    )}
  </Div>
)
